import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api.js";
import type { MainPage, MainPageBlock } from "@templestay/db";

type ActivePageResponse = {
  page: MainPage;
  blocks: MainPageBlock[];
  language: string;
  redirect?: string;
};

export function useActivePage(lang: string) {
  return useQuery({
    queryKey: ["active-page", lang],
    queryFn: () =>
      api.get<ActivePageResponse>(`/api/main-pages/active?lang=${lang}`),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
